// extracted by mini-css-extract-plugin
export default {"wrapper":"bzBz5","title":"kQ1VJ","linksWrapper":"UKzvH","linkSection":"rSvMs","linkIconsWrapper":"T0q71","linkIcon":"mRLma","linkIconPlus":"tgllI","linkTitle":"IQoeC"};